import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import { ADMIN_USER, backendUrl, CUSTOM_SELECT_STYLES, HOLDERS, SELECT_BOX_THEME } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import {
  startLoaderAction,
  stopLoaderAction,
} from "../../actions/updateReducerValue";
import { addNewChannelAction, addParticipantAction, removeParticipantAction } from "../../actions/chat";
import { getAllUserListAction, getProfileAction } from "../../actions/user";
import toast from "react-hot-toast";
import { RoutesPaths } from "../../Router/constant";
import { useNavigate } from "react-router";
import { createChat, modifyChat } from "../../services/api";
import { getAdminListAction } from "../../actions/auth";

export default function ManagePeople({
  messageModal,
  addModalClose,
  participants,
  currentConvoSid,
  setNewChat,
  setSelected,
  newChat
}) {
  const {
    register,
    control,
    getValues,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { adminList } = useSelector((state) => state.auth);
  const { allUserList } = useSelector((state) => state.user);
  const { channelList } = useSelector((state) => state.chat);
  const [chatShowUserList, SetChatShowUserList] = useState([])
  const [chatUserList, setChatUserList] = useState([])
  const [removedUser, setRemovedUser] = useState([]);
  const [isShowChatBtn, setisShowChatBtn] = useState(false);
  const groupNameWatch = watch('channel_name')

  useEffect(() => {
    const setHoldersValue = () => {
      if (allUserList.length > 0) {
        SetChatShowUserList(allUserList)
        if (adminList.length > 0) {
          SetChatShowUserList([...adminList, ...allUserList])
        }
      }
    }
    setHoldersValue()
  }, [allUserList, adminList])

  const onSubmit = async (data) => {
    try {
      let membersToAdd = [];
      let existingEmails = participants.map(p => p.id);
      let removedEmails = removedUser;

      // Filter only new members (not in participants and not already marked for removal)
      chatUserList.forEach(user => {
        const identifier = user.id || user?._id;
        if (!existingEmails.includes(identifier) && !removedEmails.includes(identifier)) {
          membersToAdd.push(identifier);
        }
      });

      if (!newChat) {
        dispatch(startLoaderAction());

        // Prepare payloads based on filtered data
        if (removedUser.length > 0) {
          await startChat({ removeParticipants: removedUser });
        }

        if (membersToAdd.length > 0) {
          await startChat({ addParticipants: membersToAdd });
        }

        dispatch(stopLoaderAction());
        addModalCloseFunc();
      } else {
        if (membersToAdd.length > 0 && data?.channel_name) {
          dispatch(startLoaderAction());
          const payloadMemberList = chatShowUserList.filter(item => membersToAdd.includes(item.id || item._id));
          await createChat({ participants: payloadMemberList.map(x => x.id || x._id), name: data?.channel_name, message: "Welcome to InProved, feel free to discuss diversifying to gold and silver bullion so we can propose the best investment exposure and hedging strategy specific to your financial objectives." });
          reset();
          addModalCloseFunc();
          await dispatch(getProfileAction());
          dispatch(stopLoaderAction());
        } else {
          toast.error("Something went wrong, please try again later.");
        }
      }
    } catch (e) {
      dispatch(stopLoaderAction());
    }
  };

  const startChat = async (payload) => {
    var resp = await modifyChat(currentConvoSid, JSON.stringify(payload));
    setSelected(resp)
  };

  const removeChatUser = (index, id) => {
    const newList = [...chatUserList];
    newList.splice(index, 1);
    setChatUserList(newList);
    if (id) {
      const prepareRemovedUser = removedUser;
      if (!prepareRemovedUser.includes(id)) {
        setRemovedUser([...removedUser, id])
      }
    }
  };

  useEffect(() => {
    const innserFunction = () => {
      dispatch(getAllUserListAction())
      dispatch(getAdminListAction())
      const condition = setNewChat ? 0 : 1
      const verifyCondition = setNewChat ? groupNameWatch?.length > 0 ? true : false : true
      setisShowChatBtn(chatUserList.length > condition && verifyCondition);
    }
    innserFunction()
  }, [setNewChat, groupNameWatch, chatUserList, dispatch]);

  useEffect(() => {
    if (messageModal) {
      const effectUpdate = () => {
        if (!setNewChat) {
          setChatUserList([...chatUserList, ...participants]);
        }
      }
      effectUpdate()
    }
  }, [messageModal]);


  const onChange = (obj) => {
    const exists = chatUserList.find((user) => (user.email === obj.email) || (user.id === obj.id));
    if (exists) return;
    setChatUserList([...chatUserList, obj]);
  };


  const addModalCloseFunc = () => {
    SetChatShowUserList([])
    setChatUserList([])
    setRemovedUser([])
    addModalClose();
  }

  const showRemove = (identity) => {
    let returnVal = true;
    if (ADMIN_USER.includes(identity)) {
      returnVal = false
    }
    return returnVal
  }

  return (
    <>
      <Modal
        show={messageModal}
        onHide={addModalCloseFunc}
        className="custom-modal add-new-member"
        id="addModalMessage"
      >
        <div className="modal-header p-0">
          <button
            type="button"
            className="btn-close text-dark close-button"
            onClick={addModalCloseFunc}
          ></button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xl-12">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-lg-12">
                    <h5 className="edit-title">
                      Add/Remove chat members
                    </h5>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group message-section">
                      <Controller
                        render={() => (
                          <Select
                            theme={SELECT_BOX_THEME}
                            styles={CUSTOM_SELECT_STYLES}
                            options={chatShowUserList}
                            getOptionLabel={(option) => `${option.first_name} ${option.last_name} (${option.email}) ${option?.role ? `(${option?.role})` : ""}`}
                            getOptionValue={(option) => option.email}
                            value=""
                            onChange={onChange}
                            placeholder="Invite people to join the conversation..."
                          />
                        )}
                        name="select"
                        control={control}
                      />
                    </div>
                  </div>

                  {setNewChat && (
                    <div className="col-lg-12 mt-3">
                      <p className="input-text heading">Group name</p>
                      <input
                        maxLength={50}
                        autoComplete="off"
                        type="text"
                        className="form-control"
                        placeholder="Enter group name"
                        {...register("channel_name", {
                          required: true,
                        })}
                      />
                      {errors.channel_name?.type === "required" && (
                        <span className="errorMessage">
                          Channel name is required
                        </span>
                      )}
                    </div>
                  )}

                  <div className="col-lg-12 mt-4 conversation-text-margin">
                    <p className="conversation-text mb-3">
                      Have a conversation with:
                    </p>
                    <div className="row conversation-section" id="style-1 customScroll">
                      {chatUserList &&
                        chatUserList.length > 0 &&
                        chatUserList.map((item, index) => (
                          <div
                            key={index}
                            className="col-lg-12 inner-section"
                          >
                            {item.identity ? (
                              <div
                                className="profile-img"
                                style={{
                                  backgroundImage: `url(${item &&
                                    item.attributes &&
                                    item.attributes.image
                                    ? backendUrl + item.attributes.image
                                    : "assets/img/Frame1.svg"
                                    })`,
                                }}
                              ></div>
                            ) : (
                              <div
                                className="profile-img"
                                style={{
                                  backgroundImage: `url(${item &&
                                    item.profilePic &&
                                    item.profilePic.filename
                                    ? backendUrl + item.profilePic.filename
                                    : "assets/img/Frame1.svg"
                                    })`,
                                }}
                              ></div>
                            )}
                            <div className="profile-name">
                              {item.email ? (
                                item.name || item.email
                              ) : (
                                ('position' in item) ? item.name : item.first_name + " " + item.last_name
                              )}
                              {showRemove(item.email) && (
                                <img
                                  src="assets/img/Close-circle.svg"
                                  alt=""
                                  className="cursor-pointer"
                                  onClick={() => removeChatUser(index, item.id ? item.id : null)}
                                />
                              )}
                            </div>
                            {/* {!item.identity && (
                              <>
                                {!item.isEditApproved && !item.isAppoint && (
                                  <span>Amendement in progress</span>
                                )}
                                {!item.isDeleteApproved && (
                                  <span>Removal in progress</span>
                                )}
                                {!item.isApproved ||
                                  (item.isAppoint && item.isDeleteApproved && (
                                    <span>Acceptance in progress</span>
                                  ))}
                              </>
                            )} */}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <p className="import-note">Important Note: <span className="will-need-text">Please be aware that newly added members can still access previous chat messages. </span></p>
                <div className="modal-footer modal-bottom-action justify-content-center">
                  {isShowChatBtn && (
                    <button type="submit" className="btn agree-button">
                      Save changes
                    </button>
                  )}
                  {!isShowChatBtn && (
                    <button
                      type="button"
                      disabled
                      className="btn disable-agree-button"
                    >
                      Save changes
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
